<template>
  <!-- <section class="header-container"> -->
  <section class="header-container">
    <div class="fillter" ></div>
    <b-container>
      <div class="taps-container">
        <b-tabs content-class="mt-3">
          <b-tab title="مصر" active>
            <b-row>
              <b-col sm="4" class="range-date-container">
                <h3>التاريح</h3>
                <DatePicker v-model="range" placeholder="اختر التاريخ"/>
              </b-col>
              <b-col sm="4" class="center-items-top price-container">
                <h3>السعر</h3>
                <b-form-select v-model="selectedPrice" :options="worldDestenations"></b-form-select>
                <!-- <VueSlider v-model="value"  :min="10" :max="500" :interval="2"></VueSlider> -->
              </b-col>
              <b-col sm="4">

                <h3>افضل الاماكن</h3>
                <b-form-input
                placeholder="افضل الأماكن"
                @click="bestPlacesShow = true"
                v-model="bestPlacesValue"
                ></b-form-input>

                <transition name="slide">
                  <BestPlaces
                  v-if="bestPlacesShow"
                  @placeClicked="changePlaceValue"
                  @customMouseLeave="hideBestPlaces"
                  />
                </transition>
              </b-col>
            </b-row>
            <b-row class="search-container">
              <b-button variant="outline-primary">بحث</b-button>
            </b-row>
          </b-tab>
          <b-tab title="العالم">
            <b-row>
              <b-col sm="4" class="range-date-container">
                <h3>التاريح</h3>
                <DatePicker v-model="range" placeholder="اختر التاريخ"/>
              </b-col>
              <b-col sm="4" class="center-items-top price-container">
                <h3>السعر</h3>
                <b-form-select v-model="selectedPrice" :options="worldDestenations"></b-form-select>
                <!-- <VueSlider v-model="value"  :min="0" :max="500" :interval="2"></VueSlider> -->
              </b-col>
              <b-col sm="4">
                <h3>افضل الاماكن</h3>
                <b-form-input
                placeholder="افضل الأماكن"
                @click="bestPlacesShow = true"
                v-model="bestPlacesValue"
                ></b-form-input>
                <transition name="slide">
                  <BestPlaces
                  v-if="bestPlacesShow"
                  @placeClicked="changePlaceValue"
                  @customMouseLeave="hideBestPlaces"
                  />
                </transition>
              </b-col>
            </b-row>
            <b-row class="search-container">
              <b-button variant="outline-primary">بحث </b-button>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </b-container>
  </section>
</template>
<script>

import BestPlaces      from './BestPlaces'
import DatePicker from 'vue2-datepicker';


//css
import 'vue2-datepicker/index.css';



export default {
  name: "Header",
  components: {
    BestPlaces,
    DatePicker
  },

  data() {
    return {
      bestPlacesShow:false,
      bestPlacesValue:null,
      range:null,
      value:[100,400],
      selectedPrice:null,
      worldDestenations: [
        { value: null, text: 'اختر السعر' },
        { value: 'a', text: '10 ~ 100' },
        { value: 'b', text: '100 ~ 1000' },
        { value: 'c', text: 'x > 1000' },
      ],


    }
  },
  methods: {
    changePlaceValue(value) {
      this.bestPlacesValue = value
    },
    hideBestPlaces() {
      this.bestPlacesShow = false;
    },
    //resize elements
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },


  },
  mounted() {

  },
}
</script>
<style media="screen">
  .mx-datepicker {
    width: 100%;
  }
</style>
